import { render, staticRenderFns } from "./PickuppForm.vue?vue&type=template&id=1ea629bd&scoped=true&"
import script from "./PickuppForm.vue?vue&type=script&lang=js&"
export * from "./PickuppForm.vue?vue&type=script&lang=js&"
import style0 from "./PickuppForm.vue?vue&type=style&index=0&id=1ea629bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea629bd",
  null
  
)

export default component.exports